<template>
  <div v-frag>
    <b-dropdown-group :header="groupName">
      <b-dropdown-item-button @click="onClickDropdownGroup">
        {{ groupContent }}
        <i class="material-icons material-icons-small">keyboard_arrow_right</i>
      </b-dropdown-item-button>
    </b-dropdown-group>
    <b-dropdown-divider v-if="dropdownDivider" class="line-divider pb-2"></b-dropdown-divider>
  </div>
</template>
<script>
export default {
  props: {
    dropdownDivider: {
      type: Boolean,
      default: false
    },
    groupName: {
      type: String,
      default: ''
    },
    groupContent: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClickDropdownGroup() {
      this.$emit('clickDropdownGroup')
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/custom-components/DropdownGroupComponent.vue